import { useParking } from '@repo/domain-service';
import { TestId } from '@repo/test-id';

import QrContents from '@features/reservation/components/QrContents';

import PleaseWaitAnimation from '@shared/components/PleaseWaitAnimation';
import { useParkingSearchStore } from '@shared/stores/useParkingSearchStore';

export default function QrPage() {
  const parkingSlug = useParkingSearchStore((state) => state.selectedParking.slug);
  const spotId = useParkingSearchStore((state) => state.selectedParking.spotId);
  const { parking, loadingParking } = useParking(parkingSlug!);

  const testId = TestId.root('reservation.qrPage');

  if (loadingParking) return <PleaseWaitAnimation testId={testId} />;

  if (!parking) return null;

  return <QrContents testId={testId} parking={parking} spotId={spotId} />;
}
